const zoomCheck = () => {

const zoomLevels = {
    16: "100",
    18: "110",
    19: "120",
    21: "130",
    22: "140",
    24: "150",
    26: "160",
    27: "170",
    29: "180",
    30: "190",
    32: "200"
};

setInterval(function() {
    let currentZoom = document.getElementById('zoomCheck').offsetWidth;
    let bodyEl = document.querySelector('body');
    if(parseFloat(getComputedStyle(document.getElementById('zoomCheck')).letterSpacing) > 0.16) {
        bodyEl.setAttribute('data-extra-text-spacing', 'true');
    }
    else {
        bodyEl.removeAttribute('data-extra-text-spacing');
    }
    switch (currentZoom) {
        case 16:
            bodyEl.setAttribute('data-text-zoom', zoomLevels[currentZoom]);
            break;
        case 18:
            bodyEl.setAttribute('data-text-zoom', zoomLevels[currentZoom]);
            break;
        case 19:
            bodyEl.setAttribute('data-text-zoom', zoomLevels[currentZoom]);
            break;
        case 21:
            bodyEl.setAttribute('data-text-zoom', zoomLevels[currentZoom]);
            break;
        case 22:
            bodyEl.setAttribute('data-text-zoom', zoomLevels[currentZoom]);
            break;
        case 24:
            bodyEl.setAttribute('data-text-zoom', zoomLevels[currentZoom]);
            break;
        case 26:
            bodyEl.setAttribute('data-text-zoom', zoomLevels[currentZoom]);
            break;
        case 27:
            bodyEl.setAttribute('data-text-zoom', zoomLevels[currentZoom]);
            break;
        case 29:
            bodyEl.setAttribute('data-text-zoom', zoomLevels[currentZoom]);
            break;
        case 30:
            bodyEl.setAttribute('data-text-zoom', zoomLevels[currentZoom]);
            break;
        case 32:
            bodyEl.setAttribute('data-text-zoom', zoomLevels[currentZoom]);
            break;
        default:
            break;
    };
}, 1000);
}

export default () => {
    zoomCheck();
};